/***Dependencies */
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

/**Components */
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
  Tab,
  Tabs,
} from "react-bootstrap";
import Flatpickr from "react-flatpickr";
import { DestinationList } from "./DestinationList";
import { PaxSelector } from "./PaxSelector";

/**Styles */
import "../styles/index.scss";

/**Images */
import { CiCalendar, CiClock2, CiSearch } from "react-icons/ci";
import destinoIcon from "../images2/icons/destino.png";
import personIcon from "../images2/icons/person.png";
import calendarIcon from "../images2/icons/calendar.png";
import { locale, setLabelPax, setLabelPersonsPax } from "../helpers";
import {
  getCountriesCode,
  getDestinations,
  getDestinationsAct,
  getTerminalesPaisTraslados,
} from "../services/searchService";
import Swal from "sweetalert2";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import { FaLocationDot } from "react-icons/fa6";
import { IoLocationOutline } from "react-icons/io5";
import { BsPeople } from "react-icons/bs";

/**
 * Componente principal que muestra el banner con carrusel, inputs de búsqueda y selector de habitaciones.
 * @param {array} imgsBanner - Arreglo de objetos con propiedades "image" que contienen la ruta de
 *                              las imágenes del carrusel.
 * @param {boolean} showSearch - Indica si se muestra el formulario de búsqueda o no.
 * @returns {React.Component} - Componente principal con el banner y los inputs de búsqueda.
 */
export const SearchEngine = ({
  title,
  subtitle,
  isInfoHotel,
  isCollection,
  isModify,
  isModifyHotel,
  isHotel,
  isExperiencias,
  isTraslados,
  modifyHotel,
  hotelId,
  totalRooms,
  totalPersons,
  arrayPersons,
  destination,
  idLocation,
  arrayRooms,
  selectedDates,
  alojamientos,
  actividades,
  modifyAct,
  actId,
  PaxSelection,
  imgSection,
  hidePax,
  category,
  idCategory,
  trasladosSearch,
}) => {
  const destinos = [
    {
      id: "CUN",
      nombre: "Cancún",
    },
    {
      id: "ACA",
      nombre: "Acapulco",
    },
    {
      id: "CAB",
      nombre: "Los Cabos",
    },
    {
      id: "PES",
      nombre: "Puerto Escondido",
    },
    {
      id: "VLL",
      nombre: "Puerto Vallarta",
    },
    {
      id: "MZA",
      nombre: "Mazatlán",
    },
    {
      id: "TUL",
      nombre: "Tulum",
    },
    {
      id: "HUA",
      nombre: "Huatulco",
    },
  ];
  const today = new Date();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const [dates, setDates] = useState([
    new Date(today.getFullYear(), today.getMonth(), today.getDate() + 5)
      .toISOString()
      .split("T")[0],
    new Date(today.getFullYear(), today.getMonth(), today.getDate() + 7)
      .toISOString()
      .split("T")[0],
  ]);
  const navigate = useNavigate();
  const [hours, setHours] = useState(["00:00"]);
  const [hoursBack, setHoursBack] = useState(["00:00"]);
  const [nameDestination, setNameDestination] = useState(destination || "");
  const [nameTerminal, setNameTerminal] = useState("");
  const [isSelecting, setIsSelecting] = useState(false);
  const [idDestination, setIdDestination] = useState(idLocation);
  const [typeSearch, setTypeSearch] = useState(
    modifyHotel === "hotel" ? "hotel" : "destino"
  );
  const [typeSearchAct, setTypeSearchAct] = useState(
    modifyAct === "actividad" ? "actividad" : "destino"
  );
  const [showDestinationList, setShowDestinationList] = useState(false);
  const [showTerminalsList, setShowTerminalsList] = useState(false);
  const [rooms, setRooms] = useState([
    { room: 1, adults: 2, minors: 0, ages: [] },
  ]);
  const [persons, setPersons] = useState([
    {
      adults: 2,
      agesAdults: [21, 21],
      minors: 0,
      infants: 0,
      ages: [],
      agesInfants: [],
    },
  ]);
  const [hidePaxSelection, setHidePaxSelection] = useState("none");
  const [hidePaxSelectionAct, setHidePaxSelectionAct] = useState("none");
  const [labelRooms, setLabelRooms] = useState("");
  const [labelPersons, setLabelPersons] = useState("");
  const [filteredDestinations, setFilteredDestinations] = useState([]);
  const [filteredHotels, setFilteredHotels] = useState([]);
  const [filteredTerminal, setFilteredTerminal] = useState([]);
  const [countries, setCountries] = useState([]);
  const [country, setCountry] = useState([]);
  const [isCheckedAe, setIsCheckedAe] = useState("desdeAe");
  const [isCheckedBackTransfer, setIsCheckedBackTransfer] = useState(false);
  const [idTerminal, setIdTerminal] = useState();
  const [typeTerminal, setTypeTerminal] = useState();
  const [typeHotel, setTypeHotel] = useState();

  const showTabHotel =
    location.pathname === "/" || location.pathname === "/hoteles";
  const showTabActivities =
    location.pathname === "/" || location.pathname === "/experiencias";
  const showTabTranslates =
    location.pathname === "/" || location.pathname === "/traslados";
  var idCard = "";
  var idTab = "";

  switch (location.pathname) {
    case "/hoteles":
      idCard = "one-card-selector";
      break;
    case "/experiencias":
      idCard = "one-card-experiencias-selector";
      break;
    case "/traslados":
      idCard = "one-card-traslados-selector";
      break;
    default:
      break;
  }
  switch (location.pathname) {
    case "/hoteles":
      idTab = "one-tab-selector";
      break;
    case "/experiencias":
      idTab = "one-tab-experiencias-selector";
      break;
    case "/traslados":
      idTab = "one-tab-traslados-selector";
      break;
    default:
      break;
  }
  useEffect(() => {
    setLabelRooms(setLabelPax(totalRooms.length > 0 ? totalRooms : rooms));
  }, [rooms, totalRooms]);
  useEffect(() => {
    setLabelPersons(
      setLabelPersonsPax(totalPersons.length > 0 ? totalPersons : persons)
    );
  }, [persons, totalPersons]);
  /**Función para verificar si existe informacion de busqueda en el session storage.*/
  useEffect(() => {
    if (isHotel) {
      if (totalRooms.length > 0) {
        setNameDestination(destination);
        setRooms(arrayRooms);
        setIsSelecting(true);
        setDates(selectedDates);
      }
    } else if (isExperiencias) {
      if (totalPersons.length > 0) {
        setNameDestination(destination);
        setPersons(arrayPersons);
        setRooms(arrayRooms);
        setIsSelecting(true);
        setDates(selectedDates);
      }
    }
  }, [destination]);

  useEffect(() => {
    if (isTraslados) {
      // if (trasladosSearch) {
      setNameDestination(
        params.get("typeTraslado") === "desdeAe"
          ? trasladosSearch?.data?.search?.to?.description
          : trasladosSearch?.data?.search?.from?.description
      );
      setNameTerminal(
        params.get("typeTraslado") === "desdeAe"
          ? trasladosSearch?.data?.search?.from?.description
          : trasladosSearch?.data?.search?.to?.description
      );
      setShowDestinationList(false);
      setShowTerminalsList(false);

      trasladosSearch?.data?.search?.occupancy.adults &&
        setPersons([
          {
            adults: trasladosSearch?.data?.search?.occupancy.adults,
            agesAdults: [21, 21],
            minors: trasladosSearch?.data?.search?.occupancy?.children,
            infants: trasladosSearch?.data?.search?.occupancy?.infants,
            ages: [],
          },
        ]);
      // setRooms(arrayRooms);
      setIsSelecting(true);
      setDates([
        params.get("arrival") ? params.get("arrival")?.split("T")[0] : "",
        params.get("departure") ? params.get("departure")?.split("T")[0] : "",
      ]);
      setIsCheckedAe(
        params.get("typeTraslado") ? params.get("typeTraslado") : "desdeAe"
      );
      setIsCheckedBackTransfer(params.get("departure") ? true : false);
      setCountry(
        params.get("country")
          ? [{ code: params.get("country"), name: params.get("countryDesc") }]
          : []
      );
      setHours(
        params.get("arrival") ? params.get("arrival")?.split("T")[1] : ["00:00"]
      );
      setHoursBack(
        params.get("departure")
          ? params.get("departure")?.split("T")[1]
          : ["00:00"]
      );
      setTypeTerminal(
        params.get("typeTransfer") ? params.get("typeTransfer") : "desdeAe"
      );
      setTypeHotel(params.get("typeHotel") ? params.get("typeHotel") : "");

      if (isCheckedAe === "desdeAe") {
        setIdDestination(params.get("to") ? params.get("to") : "");
        setIdTerminal(params.get("from") ? params.get("from") : "");
      } else {
        setIdDestination(params.get("from") ? params.get("from") : "");
        setIdTerminal(params.get("to") ? params.get("to") : "");
      }
    }
  }, [trasladosSearch]);

  useEffect(() => {
    isModify && setDates(selectedDates);
  }, [selectedDates]);

  useEffect(() => {
    // Verificar que el input tenga al menos 4 caracteres
    if (nameDestination?.length >= 3 && !isSelecting) {
      const fetchData = async () => {
        try {
          if (isHotel && modifyHotel != "hotel") {
            const result = await getDestinations(nameDestination, "");
            setShowDestinationList(true);
            filter(result);
          } else if (isExperiencias) {
            const result = await getDestinationsAct(nameDestination);
            setShowDestinationList(true);
            filter(result);
          } else if (isTraslados) {
            const result = await getDestinations(
              nameDestination,
              `&pais=${country?.[0]?.code}`
            );
            setShowDestinationList(true);
            setShowTerminalsList(false);
            filter(result);
          }
        } catch (error) {
          console.error("Error en la llamada a la API:", error);
        }
      };

      const delayDebounceFn = setTimeout(() => {
        fetchData();
      }, 500);

      return () => clearTimeout(delayDebounceFn);
    }
  }, [nameDestination]);
  useEffect(() => {
    // Verificar que el input tenga al menos 4 caracteres
    if (nameTerminal?.length >= 3 && !isSelecting) {
      const fetchDataTerminal = async () => {
        try {
          if (isTraslados) {
            const result = await getTerminalesPaisTraslados(
              nameTerminal,
              country?.[0]?.code
            );
            const terminals = {
              terminales: result,
            };
            setShowDestinationList(false);
            setShowTerminalsList(true);
            filter(terminals);
          }
        } catch (error) {
          console.error("Error en la llamada a la API:", error);
        }
      };

      const delayDebounceFn = setTimeout(() => {
        fetchDataTerminal();
      }, 500);

      return () => clearTimeout(delayDebounceFn);
    }
  }, [nameTerminal]);

  const filter = (filter) => {
    if (isHotel) {
      const destinosFiltrados = filter?.destinos?.slice(0, 10);
      const hotelesFiltrados = filter?.hoteles?.slice(0, 10);
      setFilteredDestinations(destinosFiltrados);
      setFilteredHotels(hotelesFiltrados);
    } else if (isExperiencias) {
      const destinosFiltrados = filter?.destinos?.slice(0, 10);
      setFilteredDestinations(destinosFiltrados);
    } else if (isTraslados) {
      const terminalesFiltradas = filter?.terminales?.slice(0, 10);
      const hotelesFiltrados = filter?.hoteles?.slice(0, 10);
      setFilteredTerminal(terminalesFiltradas);
      setFilteredHotels(hotelesFiltrados);
    }
  };

  const handleChangeCountry = (e) => {
    setCountry(e);
    // setNameDestination("");
    // setNameTerminal("");
    // setShowDestinationList(false);
    // setShowTerminalsList(false);
    // setFilteredDestinations([]);
    // setFilteredTerminal([]);
    // setFilteredHotels([]);
  };

  /**
   * Construye una URL con parámetros de búsqueda de alojamiento y navega hasta ella.
   * La URL incluye destino, fechas de entrada y salida, número de habitaciones,
   * y detalles de las habitaciones incluyendo adultos, menores y sus edades.
   * Utiliza `navigate` de React Router para redirigir a la URL generada.
   */
  const redirectResults = () => {
    if (!nameDestination?.trim() && !isModify) {
      Swal.fire({
        icon: "error",
        title: "El campo de destino no puede estar vacio.",
        text: "Por favor intentelo de nuevo.",
      });
    } else {
      if (isHotel) {
        const ages = rooms?.map((room) => room?.ages);
        if (ages?.find((age) => age.some((age) => age === 0))) {
          Swal.fire({
            icon: "error",
            title: "La edad de los menores debe de ser mayor a 0.",
            text: "Por favor ingrese una edad valida.",
          });
          return;
        }
        const destino = modifyHotel === "hotel" ? hotelId : idDestination;
        const checkIn = dates[0];
        const checkOut = dates[1];

        // Crear los parámetros de habitaciones (pax)
        const paxParams = rooms
          .map((hab, index) => {
            const adultos = hab.adults;
            const menores = hab.minors;
            const edades = hab.ages.length > 0 ? hab.ages.join(",") : "0";
            return `pax${index + 1}=${adultos}|${menores}|${edades}`;
          })
          .join("&"); // Unir todos los parámetros de habitaciones con "&"

        let url = "";
        // Armar la URL completa
        if (typeSearch === "destino") {
          url = `/alojamientos?t=destino&id=${destino}&in=${checkIn}&out=${checkOut}&hab=${rooms.length}&${paxParams}`;
        } else {
          url = `/info-hotel?idHotel=${destino}&in=${checkIn}&out=${checkOut}&hab=${rooms.length}&${paxParams}`;
        }
        navigate(url);
      } else if (isExperiencias) {
        if (persons?.find((ages) => ages.ages.some((ages) => ages === 0))) {
          Swal.fire({
            icon: "error",
            title: "La edad de los menores debe de ser mayor a 0.",
            text: "Por favor ingrese una edad valida.",
          });
          return;
        }
        const destino = modifyAct === "actividad" ? actId : idDestination;
        const checkIn = dates[0];
        const checkOut = dates[1];
        // Crear los parámetros de habitaciones (pax)
        const paxParams = persons
          .map((person) => {
            const adultos = person.adults;
            const edadesAdults =
              person.agesAdults.length > 0 ? person.agesAdults.join(",") : "0";
            const menores = person.minors;
            const edades = person.ages.length > 0 ? person.ages.join(",") : "0";
            return `pax=${adultos}|${edadesAdults}|${menores}|${edades}`;
          })
          .join("&"); // Unir todos los parámetros de habitaciones con "&"
        let url = "";

        // Armar la URL completa
        if (typeSearchAct === "destino") {
          url = `/experiencias-resultado?t=destination&id=${destino}&in=${checkIn}&out=${checkOut}&${paxParams}`;
        } else {
          url = `/info-experiencia?idActividad=${destino}&idDestino=${idDestination}&in=${checkIn}&out=${checkOut}&${paxParams}`;
        }
        // Usar React Router para redirigir
        navigate(url);
      } else if (isTraslados) {
        // Destinos
        const destinoHotel = idDestination;
        const destinoTerminal = idTerminal;
        // Lenguaje
        const lang = "es";
        // Fechas
        const datesArrival = dates?.[0];
        const hoursArrival = hours;
        const datesDeparture = isCheckedBackTransfer ? dates?.[1] : "";
        const hoursDeparture = isCheckedBackTransfer ? hoursBack : "";

        // Paxes
        const paxParams = persons.map((person) => {
          const adultos = person.adults;
          const menores = person.minors;
          const infants = person.infants;
          const edades = person.ages.length > 0 ? person.ages.join(",") : "0";
          return `pax=${adultos}|${menores}|${infants}|${edades}`;
        });

        // SessionStorage
        const datosPrevios = JSON.parse(
          sessionStorage.getItem("datosReserva")
        ) || {
          hospedaje: [],
          actividades: [],
        };

        // URL
        let url = "";
        const formatDateArrival = `${datesArrival}T${hoursArrival}`;
        const formatDateDeparture = `${datesDeparture}T${hoursDeparture}`;

        url = `/traslados?lang=${lang}&country=${
          country?.[0].code
        }&countryDesc=${
          country?.[0].name
        }&typeTraslado=${isCheckedAe}&typeTransfer=${typeTerminal}&typeHotel=${typeHotel}${
          isCheckedAe === "desdeAe"
            ? `&from=${destinoTerminal}&to=${destinoHotel}`
            : `&from=${destinoHotel}&to=${destinoTerminal}`
        }&arrival=${formatDateArrival}${
          isCheckedBackTransfer ? `&departure=${formatDateDeparture}` : ""
        }&${paxParams}`;

        const setDatos = {
          hospedaje: datosPrevios?.hospedaje,
          actividades: datosPrevios?.actividades,
          traslados: [],
        };
        sessionStorage.setItem("datosReserva", JSON.stringify(setDatos));
        window.dispatchEvent(new CustomEvent("cartUpdated"));
        navigate(url);
      } else if (isCollection) {
        const checkIn = dates[0];
        const checkOut = dates[1];

        // Crear los parámetros de habitaciones (pax)
        const paxParams = rooms
          .map((hab, index) => {
            const adultos = hab.adults;
            const menores = hab.minors;
            const edades = hab.ages.length > 0 ? hab.ages.join(",") : "0";
            return `pax${index + 1}=${adultos}|${menores}|${edades}`;
          })
          .join("&"); // Unir todos los parámetros de habitaciones con "&"
        let url = "";
        // Armar la URL completa
        url = `?category=${category}&idCategory=${idCategory}&in=${checkIn}&out=${checkOut}&hab=${rooms.length}&${paxParams}`;
        const currentUrl = location.pathname + url;
        navigate(currentUrl);
      }
    }
  };

  const handleClose = () => {
    setShowDestinationList(false);
    setFilteredDestinations([]);
  };

  /**
   * Maneja los cambios en la selección de fecha formateando las fechas seleccionadas
   * en formato 'aaaa-MM-dd' y actualizando el estado con las fechas formateadas.
   * @param {Array} dates: una matriz de objetos Date que representan el rango de fechas seleccionado.
   */
  const handleDateChange = (dates) => {
    if (isTraslados) {
      if (dates.length === 2) {
        const startDate = dates[0];
        const endDate = dates[1];

        // Calcular la diferencia de días entre las fechas seleccionadas
        const diffTime = Math.abs(endDate - startDate);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        if (diffDays > 15) {
          alert("Solo puedes seleccionar un máximo de 15 días.");

          // Restablecer al estado inicial definido por el usuario
          const today = new Date();
          setDates([
            new Date(
              today.getFullYear(),
              today.getMonth(),
              today.getDate() + 5
            ).toISOString(),
            new Date(
              today.getFullYear(),
              today.getMonth(),
              today.getDate() + 7
            ).toISOString(),
          ]);
          return;
        }
      }
      // Convertimos las fechas a formato yyyy-MM-dd
      const formatted = dates.map((date) => date?.toISOString().split("T")[0]);
      setDates(formatted); // Guardamos las fechas formateadas en el estado
    } else {
      if (dates.length === 2) {
        const startDate = dates[0];
        const endDate = dates[1];

        // Calcular la diferencia de días entre las fechas seleccionadas
        const diffTime = Math.abs(endDate - startDate);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        if (diffDays > 15) {
          alert("Solo puedes seleccionar un máximo de 15 días.");

          // Restablecer al estado inicial definido por el usuario
          const today = new Date();
          setDates([
            new Date(
              today.getFullYear(),
              today.getMonth(),
              today.getHours(),
              today.getDate() + 5
            ).toISOString(),
            new Date(
              today.getFullYear(),
              today.getMonth(),
              today.getHours(),
              today.getDate() + 7
            ).toISOString(),
          ]);
          return;
        }
      }
      // Convertimos las fechas a formato yyyy-MM-dd
      const formatted = dates.map((date) => date.toISOString().split("T")[0]);
      setDates(formatted); // Guardamos las fechas formateadas en el estado
    }
  };

  const handleHourChange = (horas) => {
    const formattedHours = horas.map((hour) => hour);
    setHours(formattedHours?.toString()?.split(" ")[4]);
  };

  const handleHourBackChange = (horas) => {
    const formattedHours = horas.map((hour) => hour);
    setHoursBack(formattedHours?.toString()?.split(" ")[4]);
  };

  /**
   * Maneja la selección de un item en la lista desplegable de destinos o hoteles.
   * @param {Object} item - El objeto seleccionado que contiene la información del destino o hotel.
   * @param {string} label - El label del item seleccionado.
   * @param {string} type - El tipo de item seleccionado, puede ser "destino" o "hotel".
   */
  const handleSelect = (item, label, type) => {
    setShowDestinationList(false);
    setShowTerminalsList(false);
    setIdDestination(item);
    setNameDestination(label);

    if (isHotel) {
      setTypeSearch(type);
    } else if (isExperiencias) {
      setTypeSearchAct(type);
    }
    setIsSelecting(true);
  };
  const handleSelectTerminal = (item, label, type) => {
    setShowTerminalsList(false);
    setNameTerminal(label);
    setIdTerminal(item);
    setTypeTerminal(type);
    setIsSelecting(true);
  };

  const handleSelectHotel = (item, label, type) => {
    setShowTerminalsList(false);
    setShowDestinationList(false);
    setNameDestination(label);
    setIdDestination(item);
    setTypeHotel(type);
    setIsSelecting(true);
  };
  const toggleSwitch = () =>
    setIsCheckedBackTransfer((previousState) => !previousState);

  const countryCodes = async () => {
    try {
      const response = await getCountriesCode();
      return response;
    } catch (error) {
      throw new Error("Error fetching country codes:", error);
    }
  };

  const handleSearch = async () => {
    try {
      const response = await countryCodes();
      const data = await response;

      const countries = data
        .map((country) => ({
          name: String(country.nombre || ""),
          code: String(country.codigo || ""),
        }))
        .filter((c) => c.name.trim() !== "");

      setCountries(countries);
    } catch (error) {
      console.error("Error fetching countries:", error);
      setCountries([]);
    }
  };

  return (
    <>
      {!isModify ? (
        <>
          {imgSection?.length > 0 && (
            <>
              <h1
                className="position-absolute lugar-favorito d-md-block d-none"
                style={{ textShadow: "0 1rem 3rem rgb(0 0 0 / 51%)" }}
              >
                {title}
              </h1>
              <p
                className="lugar-favorito-subtitle d-md-block d-none"
                style={{ fontSize: "20px", position: "absolute" }}
              >
                {subtitle}
              </p>
            </>
          )}
          {isHotel && (
            <Form>
              <Row className="text-purple" style={{ position: "relative" }}>
                <Col lg={4} xs={12}>
                  <Form.Group>
                    <div
                      className="d-flex justify-content-start align-items-center buscador-input-color ps-3 p-2 mb-lg-0 mb-3"
                      onClick={() => setShowDestinationList(true)}
                    >
                      <IoLocationOutline
                        style={{ fontSize: "30px", marginLeft: "2px" }}
                      />
                      <Form.Control
                        id="destino"
                        type="text"
                        placeholder="Encuentra tu destino u hotel"
                        style={{
                          //background: "transparent",
                          border: "0",
                          fontSize: "17px",
                          padding: "0.9rem 0.2rem",
                          fontWeight: "800",
                        }}
                        className="text-secondary bg-transparent"
                        autoComplete="off"
                        value={nameDestination}
                        onChange={(e) => (
                          setNameDestination(e.target.value),
                          setIsSelecting(false)
                        )}
                        required
                      />
                    </div>
                  </Form.Group>
                  <DestinationList
                    preDestinies={destinos}
                    showDestinationList={showDestinationList}
                    query={nameDestination}
                    filteredDestinations={filteredDestinations}
                    filteredHotels={filteredHotels}
                    isHotel={true}
                    handleSelectItem={handleSelect}
                    handleClose={handleClose}
                  />
                </Col>
                <Col lg={3} xs={12}>
                  <Form.Group>
                    <div className="d-flex justify-content-start align-items-center buscador-input-color ps-3 p-2 mb-lg-0 mb-3">
                      <CiCalendar
                        style={{ fontSize: "30px", marginLeft: "2px" }}
                      />
                      <Flatpickr
                        className="banner-principal__inputs-search__input-calendar input-group-text calendar-desktop w-100 border-inputs-search"
                        placeholder="Fecha de viaje"
                        options={{
                          minDate: new Date().fp_incr(5),
                          mode: "range",
                          showMonths: 2,
                          dateFormat: "Y-m-d",
                          // defaultDate: dates,
                          locale: locale,
                          onClose: function (
                            selectedDates,
                            // eslint-disable-next-line no-unused-vars
                            dateStr,
                            // eslint-disable-next-line no-unused-vars
                            instance
                          ) {
                            handleDateChange(selectedDates);
                          },
                        }}
                        value={dates?.[0] && dates?.[1] ? dates : ""}
                        readOnly
                        required
                        style={{
                          padding: "0.9rem 0.2rem",
                          background: "transparent",
                          border: "0",
                          fontSize: "17px",
                          fontWeight: "800",
                          textAlign: "start",
                        }}
                      />
                      <Flatpickr
                        className="banner-principal__inputs-search__input-calendar input-group-text calendar-mobile w-100 border-inputs-search text-start"
                        placeholder="Fecha de viaje"
                        options={{
                          minDate: new Date().fp_incr(5),
                          mode: "range",
                          showMonths: 1,
                          dateFormat: "Y-m-d",
                          //defaultDate: dates,
                          locale: locale,
                          onClose: function (
                            selectedDates,
                            // eslint-disable-next-line no-unused-vars
                            dateStr,
                            // eslint-disable-next-line no-unused-vars
                            instance
                          ) {
                            handleDateChange(selectedDates);
                          },
                        }}
                        value={dates?.[0] && dates?.[1] ? dates : ""}
                        readOnly
                        required
                        style={{
                          padding: "0.9rem 0.2rem",
                          background: "transparent",
                          border: "0",
                          fontSize: "17px",
                          fontWeight: "800",
                          textAlign: "start",
                        }}
                      />
                    </div>
                  </Form.Group>
                </Col>
                <Col lg={3} md={12} xs={12}>
                  <div className="d-flex justify-content-start align-items-center buscador-input-color ps-3 p-2 mb-lg-0 mb-3">
                    <BsPeople style={{ fontSize: "30px", marginLeft: "2px" }} />
                    <Form.Control
                      type="text"
                      placeholder="Habitación y Huéspedes"
                      style={{
                        //background: "transparent",
                        padding: "0.9rem 0.2rem",
                        border: "0",
                        fontSize: "17px",
                        cursor: "pointer",
                        fontWeight: "800",
                      }}
                      defaultValue={labelRooms}
                      onClick={() => setHidePaxSelection("block")}
                      className="border-inputs-search buscador-input-color"
                      id="destinies-label"
                      readOnly
                    />
                  </div>
                  <PaxSelector
                    showSelector={hidePaxSelection}
                    isHotel={true}
                    isAct={false}
                    setShowSelector={setHidePaxSelection}
                    roomsData={rooms}
                    setArrRooms={setRooms}
                    isHome={alojamientos}
                  />
                </Col>
                <Col lg={2} xs={12}>
                  <div className="d-grid gap-2" style={{ marginTop: "5px" }}>
                    <Button
                      className="w-100 p-3"
                      /* style={{
                        padding: "1rem",
                        borderRadius: "3rem",
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "50px",
                      }} */
                      onClick={redirectResults}
                      size="md"
                    >
                      <CiSearch style={{ fontSize: "30px" }} /> Buscar
                    </Button>
                  </div>
                </Col>
              </Row>
            </Form>
          )}

          {isExperiencias && (
            <Form>
              <Row className="text-purple" style={{ position: "relative" }}>
                <Col lg={4} xs={12}>
                  <Form.Group>
                    <div className="d-flex justify-content-start align-items-center buscador-input-color ps-3 p-2 mb-lg-0 mb-3">
                      <IoLocationOutline
                        style={{ fontSize: "30px", marginLeft: "2px" }}
                      />
                      <Form.Control
                        type="text"
                        placeholder="Encuentra tu destino"
                        style={{
                          background: "transparent",
                          padding: "0.9rem 0.2rem",
                          border: "0",
                          fontSize: "17px",
                          fontWeight: "800",
                        }}
                        autoComplete="off"
                        className=""
                        id="destinies-label"
                        value={nameDestination}
                        onChange={(e) => (
                          setNameDestination(e.target.value),
                          setIsSelecting(false)
                        )}
                        required
                      />
                      <DestinationList
                        preDestinies={destinos}
                        showDestinationList={showDestinationList}
                        query={nameDestination}
                        filteredDestinations={filteredDestinations}
                        isHotel={false}
                        isAct={true}
                        handleSelectItem={handleSelect}
                        handleClose={handleClose}
                      />
                    </div>
                  </Form.Group>
                </Col>
                <Col lg={3} xs={12}>
                  <Form.Group>
                    <div className="d-flex justify-content-start align-items-center buscador-input-color ps-3 p-2 mb-lg-0 mb-3">
                      <CiCalendar
                        style={{ fontSize: "30px", marginLeft: "2px" }}
                      />
                      <Flatpickr
                        className="banner-principal__inputs-search__input-calendar input-group-text calendar-desktop w-100 border-inputs-search"
                        placeholder="Fecha de viaje"
                        options={{
                          minDate: new Date().fp_incr(5),
                          mode: "range",
                          showMonths: 2,
                          dateFormat: "Y-m-d",
                          locale: locale,
                          onClose: function (
                            selectedDates,
                            // eslint-disable-next-line no-unused-vars
                            dateStr,
                            // eslint-disable-next-line no-unused-vars
                            instance
                          ) {
                            handleDateChange(selectedDates);
                          },
                        }}
                        value={dates?.[0] && dates?.[1] ? dates : ""}
                        readOnly
                        required
                        style={{
                          padding: "0.9rem 0.2rem",
                          background: "transparent",
                          border: "0",
                          fontSize: "17px",
                          fontWeight: "800",
                          textAlign: "start",
                        }}
                      />
                      <Flatpickr
                        className="banner-principal__inputs-search__input-calendar input-group-text calendar-mobile w-100 border-inputs-search text-start"
                        placeholder="Fecha de viaje"
                        options={{
                          minDate: new Date().fp_incr(5),
                          mode: "range",
                          showMonths: 1,
                          dateFormat: "Y-m-d",
                          //defaultDate: dates,
                          locale: locale,
                          onClose: function (
                            selectedDates,
                            // eslint-disable-next-line no-unused-vars
                            dateStr,
                            // eslint-disable-next-line no-unused-vars
                            instance
                          ) {
                            handleDateChange(selectedDates);
                          },
                        }}
                        value={dates?.[0] && dates?.[1] ? dates : ""}
                        readOnly
                        required
                        style={{
                          padding: "0.9rem 0.2rem",
                          background: "transparent",
                          border: "0",
                          fontSize: "17px",
                          fontWeight: "800",
                          textAlign: "start",
                        }}
                      />
                    </div>
                  </Form.Group>
                </Col>
                <Col lg={3} xs={12}>
                  <div className="d-flex justify-content-start align-items-center buscador-input-color ps-3 p-2 mb-lg-0 mb-3 position-relative">
                    <BsPeople style={{ fontSize: "30px", marginLeft: "2px" }} />

                    <Form.Control
                      type="text"
                      placeholder="Personas"
                      style={{
                        //background: "transparent",
                        padding: "0.9rem 0.2rem",
                        border: "0",
                        fontSize: "17px",
                        cursor: "pointer",
                        fontWeight: "800",
                      }}
                      className="border-inputs-search buscador-input-color"
                      id="destinies-label"
                      defaultValue={labelPersons}
                      onClick={() => setHidePaxSelectionAct("block")}
                      required
                      readOnly
                    />
                    <PaxSelector
                      showSelector={hidePaxSelectionAct}
                      isHotel={false}
                      isAct={true}
                      setShowSelector={setHidePaxSelectionAct}
                      personData={persons}
                      setArrPersons={setPersons}
                      isHome={actividades}
                    />
                  </div>
                </Col>
                <Col lg={2} xs={12}>
                  <div className="d-grid gap-2 h-100">
                    <Button onClick={redirectResults}>
                      <CiSearch style={{ fontSize: "30px" }} /> Buscar
                    </Button>
                  </div>
                </Col>
              </Row>
            </Form>
          )}

          {isTraslados && (
            <Form>
              <Row className="text-purple" style={{ position: "relative" }}>
                <Col lg={12} md={12} xs={12}>
                  <Form>
                    {["radio"].map((type) => (
                      <div
                        key={`inline-${type}`}
                        className="mb-3 text-start p-2"
                      >
                        <Form.Check
                          inline
                          label="Desde el aeropuerto"
                          name="desdeAe"
                          value="desdeAe"
                          checked={isCheckedAe === "desdeAe"}
                          onChange={(e) => setIsCheckedAe(e.target.value)}
                          type={type}
                          id={`inline-${type}-1`}
                          style={{
                            background: "transparent",
                            border: "0",
                            fontSize: "15px",
                            fontWeight: "800",
                          }}
                          className="text-dark"
                        />
                        <Form.Check
                          inline
                          label="Hacia el aeropuerto"
                          name="haciaAe"
                          value="haciaAe"
                          checked={isCheckedAe === "haciaAe"}
                          onChange={(e) => [
                            setIsCheckedAe(e.target.value),
                            setIsCheckedBackTransfer(false),
                          ]}
                          type={type}
                          id={`inline-${type}-2`}
                          style={{
                            background: "transparent",
                            border: "0",
                            fontSize: "15px",
                            fontWeight: "800",
                          }}
                          className="text-dark"
                        />
                        {isCheckedAe === "desdeAe" && (
                          <>
                            {["switch"].map((type) => (
                              <Form.Check
                                inline
                                label="Viaje redondo"
                                name="backTransfer"
                                checked={isCheckedBackTransfer}
                                value="backTransfer"
                                onChange={toggleSwitch}
                                type={type}
                                id={`inline-${type}-1`}
                                style={{
                                  background: "transparent",
                                  border: "0",
                                  fontSize: "15px",
                                  fontWeight: "800",
                                }}
                                className="text-dark"
                              />
                            ))}
                          </>
                        )}
                      </div>
                    ))}
                  </Form>
                </Col>
                <Col lg={2} md={6} xs={6}>
                  <Form.Group controlId="formPaises">
                    <div className="d-flex justify-content-start align-items-center buscador-input-color ps-3 p-2 mb-lg-0 mb-3 position-relative">
                      <IoLocationOutline
                        style={{ fontSize: "30px", marginLeft: "2px" }}
                      />
                      <AsyncTypeahead
                        id="country-search"
                        labelKey="name"
                        filterBy={["code", "name"]}
                        minLength={2}
                        defaultInputValue={params.get("countryDesc") || ""}
                        style={{
                          // background: "transparent",
                          //border: "0",
                          borderRadius: "10px",
                          fontSize: "17px",
                          flexGrow: 1,
                          fontWeight: "800",
                        }}
                        className=""
                        onChange={(e) => handleChangeCountry(e)}
                        onSearch={handleSearch}
                        options={countries}
                        placeholder="País"
                        renderMenuItemChildren={(option) => (
                          <div>
                            <span>
                              {option.name} ({option.code})
                            </span>
                          </div>
                        )}
                      />
                    </div>
                  </Form.Group>
                </Col>
                <Col lg={2} md={6} xs={6}>
                  {isCheckedAe === "desdeAe" ? (
                    <>
                      <div className="d-flex justify-content-start align-items-center buscador-input-color ps-3 p-2 mb-lg-0 mb-3 position-relative">
                        <IoLocationOutline
                          style={{ fontSize: "30px", marginLeft: "2px" }}
                        />
                        <Form.Control
                          type="text"
                          placeholder="Aeropuerto"
                          autoComplete="off"
                          value={nameTerminal}
                          style={{
                            background: "transparent",
                            padding: "0.375rem 0.2rem",
                            border: "0",
                            fontSize: "17px",
                            flexGrow: 1,
                            fontWeight: "800",
                          }}
                          className=""
                          onChange={(e) => (
                            setNameTerminal(e.target.value),
                            setIsSelecting(false)
                          )}
                          required
                        />
                      </div>
                      <DestinationList
                        showTerminalList={showTerminalsList}
                        query={nameTerminal}
                        isTrasladosHotel={false}
                        isTraslados={true}
                        filteredTerminals={filteredTerminal}
                        handleSelectedTerminal={handleSelectTerminal}
                        isCheckedTraslado={isCheckedAe}
                        handleClose={handleClose}
                      />
                    </>
                  ) : (
                    isCheckedAe === "haciaAe" && (
                      <>
                        <div className="d-flex justify-content-start align-items-center buscador-input-color ps-3 p-2 mb-lg-0 mb-3 position-relative">
                          <IoLocationOutline
                            style={{ fontSize: "30px", marginLeft: "2px" }}
                          />
                          <Form.Control
                            type="text"
                            placeholder="Hotel"
                            value={nameDestination}
                            style={{
                              background: "transparent",
                              padding: "0.375rem 0.2rem",
                              border: "0",
                              fontSize: "17px",
                              flexGrow: 1,
                              fontWeight: "800",
                            }}
                            className=""
                            onChange={(e) => (
                              setNameDestination(e.target.value),
                              setIsSelecting(false)
                            )}
                            required
                          />
                        </div>
                        <DestinationList
                          showDestinationListHotels={showDestinationList}
                          showTerminalList={false}
                          query={nameDestination}
                          isTrasladosHotel={true}
                          isTraslados={false}
                          filteredHotels={filteredHotels}
                          handleSelectItem={handleSelectHotel}
                          isCheckedTraslado={isCheckedAe}
                          handleClose={handleClose}
                        />
                      </>
                    )
                  )}
                </Col>
                <Col lg={2} md={6} xs={6}>
                  {isCheckedAe === "haciaAe" ? (
                    <>
                      <div className="d-flex justify-content-start align-items-center buscador-input-color ps-3 p-2 mb-lg-0 mb-3 position-relative">
                        <IoLocationOutline
                          style={{ fontSize: "30px", marginLeft: "2px" }}
                        />
                        <Form.Control
                          type="text"
                          placeholder="Aeropuerto"
                          value={nameTerminal}
                          autoComplete="off"
                          style={{
                            background: "transparent",
                            padding: "0.375rem 0.2rem",
                            border: "0",
                            fontSize: "17px",
                            flexGrow: 1,
                            fontWeight: "800",
                          }}
                          className=""
                          onChange={(e) => (
                            setNameTerminal(e.target.value),
                            setIsSelecting(false)
                          )}
                          required
                        />
                      </div>
                      <DestinationList
                        showTerminalList={showTerminalsList}
                        query={nameTerminal}
                        isTrasladosHotel={false}
                        isTraslados={true}
                        filteredTerminals={filteredTerminal}
                        handleSelectedTerminal={handleSelectTerminal}
                        handleClose={handleClose}
                      />
                    </>
                  ) : (
                    isCheckedAe === "desdeAe" && (
                      <>
                        <div className="d-flex justify-content-start align-items-center buscador-input-color ps-3 p-2 mb-lg-0 mb-3 position-relative">
                          <IoLocationOutline
                            style={{ fontSize: "30px", marginLeft: "2px" }}
                          />
                          <Form.Control
                            type="text"
                            placeholder="Hotel"
                            value={nameDestination}
                            style={{
                              background: "transparent",
                              padding: "0.375rem 0.2rem",
                              border: "0",
                              fontSize: "17px",
                              flexGrow: 1,
                              fontWeight: "800",
                            }}
                            className=""
                            onChange={(e) => (
                              setNameDestination(e.target.value),
                              setIsSelecting(false)
                            )}
                            required
                          />
                        </div>
                        <DestinationList
                          showDestinationListHotels={showDestinationList}
                          showTerminalList={false}
                          query={nameDestination}
                          isTrasladosHotel={true}
                          isTraslados={false}
                          filteredHotels={filteredHotels}
                          handleSelectItem={handleSelectHotel}
                          handleClose={handleClose}
                        />
                      </>
                    )
                  )}
                </Col>
                <Col lg={2} md={6} xs={6}>
                  <Form.Group controlId="formPaxSelection">
                    <div className="d-flex justify-content-start align-items-center buscador-input-color ps-3 p-2 mb-lg-0 mb-3 position-relative">
                      <BsPeople
                        style={{ fontSize: "30px", marginLeft: "2px" }}
                      />
                      <Form.Control
                        type="text"
                        readOnly
                        placeholder="¿Quiénes viajan?"
                        defaultValue={labelPersons}
                        style={{
                          background: "transparent",
                          padding: "0.375rem 0.2rem",
                          border: "0",
                          fontSize: "17px",
                          cursor: "pointer",
                          flexGrow: 1,
                          fontWeight: "800",
                        }}
                        className=""
                        onClick={() => setHidePaxSelection("block")}
                        required
                      />
                    </div>
                    <PaxSelector
                      showSelector={hidePaxSelection}
                      isHotel={false}
                      isAct={false}
                      isTraslados={true}
                      setShowSelector={setHidePaxSelection}
                      personData={persons}
                      setArrPersons={setPersons}
                      isHome={isTraslados}
                    />
                  </Form.Group>
                </Col>
                <Col lg={2} md={6} xs={6} className="m-0">
                  <Form.Group controlId="formCalendar">
                    <div className="justify-content-start calendar-desktop align-items-center buscador-input-color ps-3 p-2 mb-lg-0 mb-md-3">
                      <CiCalendar
                        style={{ fontSize: "30px", marginLeft: "2px" }}
                      />
                      <Flatpickr
                        style={{
                          padding: "0.375rem 0.2rem",
                          background: "transparent",
                          borderRadius: "10px",
                          border: "0",
                          fontSize: "17px",
                          flexGrow: 1,
                          fontWeight: "800",
                          color: "#000",

                          textAlign: "start",
                        }}
                        className="w-100"
                        placeholder={
                          isCheckedAe === "desdeAe"
                            ? "Fecha llegada"
                            : "Fecha salida"
                        }
                        options={{
                          minDate: "today",
                          enableTime: false,
                          mode: "range",
                          dateFormat: "Y-m-d",
                          time_24hr: false,
                          showMonths: 2,
                          locale: locale,
                          onClose: function (selectedDates, dateStr, instance) {
                            // Asegura que Flatpickr no avance automáticamente
                            handleDateChange(selectedDates);
                          },
                          onOpen: function (selectedDates, dateStr, instance) {
                            instance.clear(dates);
                          },
                        }}
                        value={dates?.[0] ? dates?.[0] : ""}
                      />
                    </div>
                    <div className="justify-content-start calendar-mobile align-items-center buscador-input-color ps-3 p-2 mb-lg-0 mb-md-3">
                      <CiCalendar
                        style={{ fontSize: "30px", marginLeft: "2px" }}
                      />
                      <Flatpickr
                        style={{
                          background: "transparent",
                          padding: "0.375rem 0.2rem",
                          borderRadius: "10px",
                          border: "0",
                          fontSize: "17px",
                          flexGrow: 1,
                          color: "#000",

                          fontWeight: "800",
                          textAlign: "start",
                        }}
                        className=" w-100"
                        placeholder={
                          isCheckedAe === "desdeAe"
                            ? "Fecha llegada"
                            : "Fecha salida"
                        }
                        options={{
                          minDate: "today",
                          enableTime: false,
                          mode: "range",
                          dateFormat: "Y-m-d",
                          time_24hr: false,
                          showMonths: 1,
                          locale: locale,
                          onClose: function (selectedDates, dateStr, instance) {
                            // Asegura que Flatpickr no avance automáticamente
                            handleDateChange(selectedDates);
                          },
                          onOpen: function (selectedDates, dateStr, instance) {
                            instance.clear(dates);
                          },
                        }}
                        value={dates?.[0] ? dates?.[0] : ""}
                      />
                    </div>
                  </Form.Group>
                </Col>
                <Col lg={2} md={6} xs={6}>
                  <Form.Group controlId="formCalendar">
                    <div className="d-flex justify-content-start align-items-center buscador-input-color ps-3 p-2 mb-lg-0 mb-3">
                      <CiClock2
                        style={{ fontSize: "30px", marginLeft: "2px" }}
                      />
                      <Flatpickr
                        style={{
                          background: "transparent",
                          borderRadius: "10px",
                          border: "0",
                          fontSize: "17px",
                          flexGrow: 1,
                          color: "#000",

                          padding: "0.375rem 0.2rem",
                          fontWeight: "800",
                          textAlign: "start",
                        }}
                        className=""
                        placeholder={
                          isCheckedAe === "desdeAe"
                            ? "Hora llegada"
                            : "Hora salida"
                        }
                        options={{
                          enableTime: true,
                          allowInput: false,
                          noCalendar: true,
                          dateFormat: "h:i K",
                          time_24hr: false,
                          onClose: function (selectedHour, dateStr, instance) {
                            // Asegura que Flatpickr no avance automáticamente
                            handleHourChange(selectedHour);
                          },
                        }}
                        value={hours}
                      />
                    </div>
                  </Form.Group>
                </Col>

                <Col lg={2} md={6} xs={6} className="ms-lg-auto mt-lg-2">
                  <Form.Group>
                    {isCheckedBackTransfer === true && (
                      <>
                        <div className="justify-content-start calendar-desktop align-items-center buscador-input-color ps-3 p-2 mb-lg-0 mb-md-3">
                          <CiCalendar
                            style={{ fontSize: "30px", marginLeft: "2px" }}
                          />
                          <Flatpickr
                            style={{
                              background: "transparent",
                              borderRadius: "10px",
                              border: "0",
                              padding: "0.375rem 0.2rem",
                              fontSize: "17px",
                              color: "#000",

                              flexGrow: 1,
                              fontWeight: "800",
                              textAlign: "start",
                            }}
                            className=" w-100"
                            placeholder={
                              isCheckedAe === "desdeAe"
                                ? "Fecha salida"
                                : "Fecha llegada"
                            }
                            options={{
                              minDate: "today",
                              enableTime: false,
                              mode: "range",
                              dateFormat: "Y-m-d",
                              time_24hr: false,
                              showMonths: 2,
                              locale: locale,
                              onClose: function (
                                selectedDates,
                                dateStr,
                                instance
                              ) {
                                // Asegura que Flatpickr no avance automáticamente
                                handleDateChange(selectedDates);
                              },
                              onOpen: function (
                                selectedDates,
                                dateStr,
                                instance
                              ) {
                                instance.clear(dates);
                              },
                            }}
                            value={dates?.[1] ? dates?.[1] : ""}
                          />
                        </div>
                        <div className="justify-content-start calendar-mobile align-items-center buscador-input-color ps-3 p-2 mb-lg-0 mb-md-3">
                          <CiCalendar
                            style={{ fontSize: "30px", marginLeft: "2px" }}
                          />
                          <Flatpickr
                            style={{
                              background: "transparent",
                              borderRadius: "10px",
                              border: "0",
                              padding: "0.375rem 0.2rem",
                              fontSize: "17px",
                              flexGrow: 1,
                              color: "#000",
                              fontWeight: "800",
                              textAlign: "start",
                            }}
                            className="w-100"
                            placeholder={
                              isCheckedAe === "desdeAe"
                                ? "Fecha salida"
                                : "Fecha llegada"
                            }
                            options={{
                              minDate: "today",
                              enableTime: false,
                              mode: "range",
                              dateFormat: "Y-m-d",
                              time_24hr: false,
                              showMonths: 1,
                              locale: locale,
                              onClose: function (
                                selectedDates,
                                dateStr,
                                instance
                              ) {
                                // Asegura que Flatpickr no avance automáticamente
                                handleDateChange(selectedDates);
                              },
                              onOpen: function (
                                selectedDates,
                                dateStr,
                                instance
                              ) {
                                instance.clear(dates);
                              },
                            }}
                            value={dates?.[1] ? dates?.[1] : ""}
                          />
                        </div>
                      </>
                    )}
                  </Form.Group>
                </Col>
                <Col lg={2} md={6} xs={6} className="">
                  {isCheckedBackTransfer === true && (
                    <>
                      <div className="d-flex mt-lg-2 align-items-center">
                        <div className="d-flex justify-content-start align-items-center buscador-input-color ps-3 p-2 mb-lg-0 mb-3">
                          <CiClock2
                            style={{ fontSize: "30px", marginLeft: "2px" }}
                          />
                          <Flatpickr
                            style={{
                              background: "transparent",
                              borderRadius: "10px",
                              padding: "0.375rem 0.2rem",
                              border: "0",
                              fontSize: "17px",
                              flexGrow: 1,
                              color: "#000",
                              fontWeight: "800",
                              textAlign: "start",
                            }}
                            className=""
                            placeholder={
                              isCheckedAe === "desdeAe"
                                ? "Hora salida"
                                : "Hora llegada"
                            }
                            options={{
                              enableTime: true,
                              noCalendar: true,
                              dateFormat: "h:i K",
                              time_24hr: false,
                              onClose: function (
                                selectedHour,
                                dateStr,
                                instance
                              ) {
                                // Asegura que Flatpickr no avance automáticamente
                                handleHourBackChange(selectedHour);
                              },
                            }}
                            value={hoursBack}
                          />
                        </div>
                      </div>
                    </>
                  )}
                </Col>
                <Col lg={12} xs={12} className="mt-3">
                  <div className="d-grid gap-2 mt-lg-0 justify-content-lg-end justify-content-center">
                    <Button
                      className=""
                      style={{
                        padding: "1rem",
                        width: "20rem",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "50px",
                      }}
                      onClick={redirectResults}
                      size="md"
                    >
                      <CiSearch style={{ fontSize: "30px" }} /> Buscar
                    </Button>
                  </div>
                </Col>
                {/* {isCheckedAe === "desdeAe" && (
                    <Col lg={12} md={alojamientos ? 12 : 6} xs={12}>
                      <Form>
                        {["switch"].map((type) => (
                          <div key={`inline-${type}`}>
                            <Form.Check
                              inline
                              label="Quiero agregar el regreso"
                              name="backTransfer"
                              checked={isCheckedBackTransfer}
                              value="backTransfer"
                              onChange={toggleSwitch}
                              type={type}
                              id={`inline-${type}-1`}
                            />
                          </div>
                        ))}
                      </Form>
                    </Col>
                  )} */}
              </Row>
            </Form>
          )}
        </>
      ) : (
        <div>
          <h5
            className="text-purple"
            style={{ fontSize: "20px", marginLeft: "15px" }}
          >
            Modifica tu Búsqueda
          </h5>
          <Card className="shadow border-0 rounded-4">
            <Card.Body className="shadow">
              {!isInfoHotel && (
                <h6 className="text-purple fw-normal border-bottom border-1 border-secondary pb-3">
                  Detalles
                </h6>
              )}

              <Form className="py-3">
                {!isInfoHotel && (
                  <Form.Group className="mb-3 p-2 rounded-3 border-color-search">
                    <div className="d-flex p-1">
                      <img
                        src={destinoIcon}
                        style={{ width: "auto", objectFit: "contain" }}
                        alt=""
                      />
                      <Form.Control
                        type="text"
                        placeholder="Cancún, México"
                        style={{
                          background: "transparent",
                          border: "0",
                          fontSize: "15px",
                        }}
                        className="text-secondary"
                        id="destinies-label"
                        value={nameDestination}
                        onChange={(e) => (
                          setNameDestination(e.target.value),
                          setIsSelecting(false)
                        )}
                        required
                      />
                    </div>
                    {isModifyHotel ? (
                      <>
                        <DestinationList
                          preDestinies={destinos}
                          showDestinationList={showDestinationList}
                          query={nameDestination}
                          filteredDestinations={filteredDestinations}
                          filteredHotels={filteredHotels}
                          isHotel={true}
                          handleSelectItem={handleSelect}
                          handleClose={handleClose}
                          isModify={isModify}
                        />
                      </>
                    ) : (
                      <>
                        <DestinationList
                          preDestinies={destinos}
                          showDestinationList={showDestinationList}
                          query={nameDestination}
                          filteredDestinations={filteredDestinations}
                          isHotel={false}
                          isAct={true}
                          isModify={isModify}
                          handleSelectItem={handleSelect}
                          handleClose={handleClose}
                        />
                      </>
                    )}
                  </Form.Group>
                )}

                <Form.Group className="mb-3 p-2 rounded-3 border-color-search">
                  <div className="d-flex p-1">
                    <img
                      src={calendarIcon}
                      style={{ width: "auto", objectFit: "contain" }}
                      alt=""
                    />
                    <Flatpickr
                      className="banner-principal__inputs-search__input-calendar calendar-desktop input-group-text w-100 border-inputs-search text-start buscador-input-color-white"
                      placeholder="Fecha de viaje"
                      options={{
                        minDate: new Date().fp_incr(5),
                        mode: "range",
                        showMonths: 2,
                        dateFormat: "Y-m-d",
                        defaultDate: dates,
                        locale: locale,
                        onClose: function (selectedDates, dateStr, instance) {
                          handleDateChange(selectedDates);
                        },
                      }}
                      value={dates}
                      readOnly
                      required
                      // onClick={alojamientos}
                      style={{
                        background: "transparent",
                        border: "0",
                        fontSize: "15px",
                      }}
                    />
                    <Flatpickr
                      className="banner-principal__inputs-search__input-calendar calendar-mobile input-group-text w-100 border-inputs-search text-start buscador-input-color-white"
                      placeholder="Fecha de viaje"
                      options={{
                        minDate: new Date().fp_incr(5),
                        mode: "range",
                        showMonths: 1,
                        dateFormat: "Y-m-d",
                        defaultDate: dates,
                        locale: locale,
                        onClose: function (selectedDates, dateStr, instance) {
                          handleDateChange(selectedDates);
                        },
                      }}
                      value={dates}
                      readOnly
                      required
                      // onClick={alojamientos}
                      style={{
                        background: "transparent",
                        border: "0",
                        fontSize: "15px",
                      }}
                    />
                  </div>
                </Form.Group>

                <Form.Group
                  className="mb-3 p-2 rounded-3 border-color-search"
                  // controlId="formHuespedes"
                >
                  <div className="d-flex p-1">
                    <img
                      src={personIcon}
                      style={{ width: "auto", objectFit: "contain" }}
                      alt=""
                    />
                    <Form.Control
                      type="text"
                      placeholder="Habitación y Huéspedes"
                      style={{
                        background: "transparent",
                        border: "0",
                        fontSize: "15px",
                        cursor: "pointer",
                      }}
                      className="text-secondary border-inputs-search"
                      id="destinies-label"
                      defaultValue={isModifyHotel ? labelRooms : labelPersons}
                      onClick={() =>
                        isModifyHotel
                          ? setHidePaxSelection("block")
                          : setHidePaxSelectionAct("block")
                      }
                      required
                      readOnly
                    />
                  </div>
                  {isModifyHotel ? (
                    <PaxSelector
                      showSelector={hidePaxSelection}
                      isHotel={true}
                      isAct={false}
                      setShowSelector={setHidePaxSelection}
                      roomsData={rooms}
                      setArrRooms={setRooms}
                      isHome={alojamientos}
                    />
                  ) : (
                    <>
                      <PaxSelector
                        showSelector={hidePaxSelectionAct}
                        isHotel={false}
                        isAct={true}
                        setShowSelector={setHidePaxSelectionAct}
                        personData={persons}
                        setArrPersons={setPersons}
                        roomsData={[]}
                        setArrRooms={[]}
                        isHome={actividades}
                      />
                    </>
                  )}
                </Form.Group>
                <div className="d-flex justify-content-center w-100">
                  <div className="d-flex justify-content-center w-100">
                    <Button
                      className="btn-blue w-100"
                      style={
                        isCollection
                          ? {
                              padding: "1rem",
                              borderRadius: "3rem",
                              width: "40%",
                              height: "45px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }
                          : {
                              padding: "1rem",
                              borderRadius: "3rem",
                              width: "100%",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }
                      }
                      onClick={redirectResults}
                      size="md"
                    >
                      <CiSearch style={{ fontSize: "30px" }} /> Buscar
                    </Button>
                  </div>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </div>
      )}
    </>
  );
};
